if (!customElements.get('product-modal')) {
  customElements.define('product-modal', class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('is-active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('is-active');
      this.scrollToActiveMedia(activeMedia);

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }

    // Scroll the modal to the clicked media reliably. The stock theme used
    // activeMedia.scrollIntoView() called synchronously as the modal opens, while
    // its open animation is still tweening transform: scale(). scrollIntoView
    // measures geometry, and geometry inside a mid-animation scaled container can
    // be off — intermittently landing on the wrong image (desktop, "no pattern").
    // offsetTop is layout-based and transform-independent, so it is stable; we
    // re-assert on the next frame to also absorb any late layout shift from an
    // image above the target finishing load. Requires .product-media-modal__content
    // to be positioned (see section-main-product.css) so offsetTop is relative to it.
    scrollToActiveMedia(activeMedia) {
      const scroller = this.querySelector('.product-media-modal__content');
      if (!scroller) {
        activeMedia.scrollIntoView();
        return;
      }
      // Distance from the top of the scroller to the active media, summed via
      // offsetTop (layout-based, so unaffected by the modal's open-scale transform
      // or by the theme editor's scroll handling — both of which throw off
      // scrollIntoView and open the modal on the wrong image).
      const offsetWithinScroller = () => {
        let top = 0;
        let node = activeMedia;
        while (node && node !== scroller && scroller.contains(node)) {
          top += node.offsetTop;
          node = node.offsetParent;
        }
        return top;
      };
      const align = () => { scroller.scrollTop = offsetWithinScroller(); };
      align();
      // Re-assert after layout settles (late-loading image above the target, or an
      // in-flight open transition).
      requestAnimationFrame(align);
    }
  });
}
